import styled from "styled-components";

import { ConsolePageButtonStyles } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageButton/styles";

export const RegisterAndLoginButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  button {
    font: 600 0.875rem/1.3125rem "Inter";
  }

  .search {
    font-size: 0;
  }
`;

export const LoginButton = styled(ConsolePageButtonStyles)`
  background-color: #ffffff0a;
  color: #ffffff;
  border: 1px solid #ffffff0a;

  backdrop-filter: blur(40px);
`;

export const RegisterButton = styled(ConsolePageButtonStyles)`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.textMasterColor};

  :hover {
    background-color: ${({ theme }) => theme.colors.secondary};
  }
`;
